import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-4 font-heading">
            Loved by learners
          </h2>
          <p className="text-base sm:text-lg text-foreground-600 max-w-xl mx-auto">
            Join thousands of students who've transformed their careers with AI.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div key={t.id}>
              <div className="flex flex-col gap-6 rounded-xl border border-background-200 bg-background-50 text-foreground-900 shadow-sm h-full">
                <div className="p-5 md:p-6 flex flex-col gap-4">
                  {/* Stars */}
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm w-3.5 h-3.5 flex items-center justify-center ${
                          i < t.rating ? 'text-primary-400' : 'text-background-300'
                        }`}
                      />
                    ))}
                  </div>

                  <p className="text-sm text-foreground-800 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>

                  <div className="mt-auto flex items-center gap-3">
                    <div
                      className={`w-9 h-9 rounded-full ${t.initialsBg} flex items-center justify-center text-background-50 text-xs font-bold shrink-0`}
                    >
                      {t.initials}
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>

                  <p className="text-xs text-primary-600 font-medium">{t.course}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}